(function(window, app, overwatch, $, _) {
    var home = {};

    var util = overwatch.util;

    var CLASS_PORTRAIT_ACTIVE = 'is-active';

    //https://gist.github.com/webcyou/a1093f2f1b4533cf3f7a
    //TODO move to lib for other people?
    var whichAnimationEvent = function whichAnimationEvent(){
        var t,
        el = document.createElement("fakeelement");

        var animations = {
            "animation"	        : "animationend",
            "OAnimation"	    : "oAnimationEnd",
            "MozAnimation"	    : "animationend",
            "WebkitAnimation"   : "webkitAnimationEnd"
        };

        for (t in animations){
            if (el.style[t] !== undefined){
                return animations[t];
            }
        }
        return false;
    }();

    home.registerSpotlight = function registerSpotlight(element) {
        var spotlight = new overwatch.Spotlight(element);
    };

    home.trailerSetup = function trailerSetup() {
        var headerVideo = $('[data-js="header-video"]').get(0);
        $('[data-js="video-lightbox"]').on('click', function(event){
            var videoId = $(this).data('yt-id');
            if(!util.mobile() && !util.touch()){
                event.preventDefault();

                // pause bg video
                headerVideo.pause();

                // play video in lightbox
                app.helpers.loadVideoIntoFrame(videoId, {
                    closeCallback: function closeCallback() {
                        // resume bg video when lightbox closed
                        headerVideo.play();
                    }
                });
            }
        });
    };

    home.rotatingCTA = function rotatingCTA() {
        var $allBtnArt = $('.buy-cta .btn-art');
        var currentTransIn = 1;
        var currentTransOut = 0;

        var transIn = function transIn(index) {
            $($allBtnArt[index]).removeClass('trans-out').addClass('trans-in');
        };

        var transOut = function transOut(index) {
            $($allBtnArt[index]).removeClass('trans-in').addClass('trans-out');
        };

        $.each($allBtnArt, function(index, el) {
            $(el).on(whichAnimationEvent, function(e) {
                if($(this).hasClass('trans-in')) {
                    //TODO perhaps use MOD to simplify?
                    currentTransIn = (index+1 > $allBtnArt.length-1) ? 0 : index+1;
                    currentTransOut = index;
                    transOut(currentTransOut);
                    transIn(currentTransIn);
                }
            });
        });

        if(whichAnimationEvent !== false) {
            setTimeout(function() {
                $allBtnArt.removeClass('fallback');
                transIn(currentTransIn);
                transOut(currentTransOut);
            }, 3000);
        }
    };

    home.fftfBGTransition = function fftfBGTransition() {
        var $backgrounds = $('.bg-fftf');
        var currentTransIn = 0;
        var currentTransOut = 2;

        var transIn = function transIn(index) {
            $($backgrounds[index]).removeClass('trans-out').addClass('trans-in');
        };

        var transOut = function transOut(index) {
            $($backgrounds[index]).removeClass('trans-in').removeClass('trans-out').addClass('trans-out-latest');
        };

        $.each($backgrounds, function(index, el) {
            $(el).on(whichAnimationEvent, function(e) {
                if($(this).hasClass('trans-in')) {
                    //TODO perhaps use MOD to simplify?
                    currentTransIn = (index+1 > $backgrounds.length-1) ? 0 : index+1;
                    currentTransOut = index;
                    $backgrounds.removeClass('trans-out-latest').addClass('trans-out');
                    transOut(currentTransOut);
                    transIn(currentTransIn);
                }
            });
        });
    };

    home.setupAnnouncementEvents = function() {
        //Open when clicking PS4/Xbox button
        $('[data-js=platform-instructions-button]').on('click', function(event){
            var $this = $(this);
            var platform = $this.data("platform");
            $('[data-js='+platform+'-instructions]').addClass('open');
        });

        //Close when clicking 'x' icon
        $('[data-js=instructions-exit-btn]').on('click', function(){
            var $this = $(this);
            var platform = $this.data("platform");
            $('[data-js='+platform+'-instructions]').removeClass('open');
        });

        //Close when clicking outside the panel
        $('[data-js=ps4-instructions]').on('click', function(){
            var $this = $(this);
            $this.removeClass('open');
        });
        $('[data-js=xbox-instructions]').on('click', function(){
            var $this = $(this);
            $this.removeClass('open');
        });

        $('[data-js=instructions-container]').on('click', function(event) {
            event.stopPropagation();
        });
    }

    home.init = function init() {
        // register all spotlight components on this page
        Array.prototype.forEach.call(document.querySelectorAll('[data-js=spotlight]'), this.registerSpotlight);
        this.trailerSetup();
        this.rotatingCTA();
        this.fftfBGTransition();
        this.setupAnnouncementEvents();
    };

    app.extend({ home: home });

}(window, window.app, window.overwatch, window.jQuery, window._));
